import $store from '@/store'
import DateUtils from '@/utils/dateUtils'
import { MessageBox } from 'element-ui'
import lang from '@/lang'
import { cache } from '@/utils/cacheManager'
import * as InvoiceConstant from '@/class/cargo/model/parameters/InvoiceConstant'

export class BSWarningUtil {
  /**
   * 校验财务模块到期日
   * @param $route
   * @param $router
   */
  static checkFinanceExpire($route, $router) {
    return new Promise((resolve, reject) => {
      const financeInvalidDate = $store.state.settings.bsLimitInfo.financeInvalidDate
      if (financeInvalidDate && financeInvalidDate < DateUtils.formatStandardDate(new Date())) {
        MessageBox.confirm(lang.t('SystemMaintenance.TaxExpireLimitUse'), lang.t('SystemMaintenance.Prompt'), {
          confirmButtonText: lang.t('common.btn.ok'),
          dangerouslyUseHTMLString: true,
          showCancelButton: false,
          closeOnClickModal: false,
          showClose: false,
          closeOnPressEscape: false,
          type: 'warning'
        }).then(() => {
          $store.dispatch('tagsView/delView', $route).then(({ visitedViews }) => {
            this.toLastView(visitedViews, $router)
          })
          resolve(false)
        }).catch(() => {
          $store.dispatch('tagsView/delView', $route).then(({ visitedViews }) => {
            this.toLastView(visitedViews, $router)
          })
          resolve(false)
        })
      } else {
        resolve(true)
      }
    })
  }

  /**
   * 校验EDI订舱接口到期日
   * @param $route
   * @param $router
   */
  static checkEDIExpire() {
    return new Promise((resolve, reject) => {
      const ediInvalidDate = $store.state.settings.bsLimitInfo.ediInvalidDate
      if (ediInvalidDate && ediInvalidDate < DateUtils.formatStandardDate(new Date())) {
        MessageBox.confirm(lang.t('SystemMaintenance.EdiExpireLimitUse'), lang.t('SystemMaintenance.Prompt'), {
          confirmButtonText: lang.t('common.btn.ok'),
          dangerouslyUseHTMLString: true,
          showCancelButton: false,
          closeOnClickModal: false,
          showClose: false,
          closeOnPressEscape: false,
          type: 'warning'
        }).then(() => {
          resolve(false)
        }).catch(() => {
          resolve(false)
        })
      } else {
        resolve(true)
      }
    })
  }

  /**
   * 校验税控服务到期日
   * @param $route
   * @param $router
   */
  static checkTaxExpire() {
    return new Promise((resolve, reject) => {
      let taxInvalidDate
      const EITaxControlInterfaceName = String(cache.config.get('EITaxControlInterfaceName'))
      const TaxControlInterfaceName = String(cache.config.get('TaxControlInterfaceName'))
      if (EITaxControlInterfaceName === InvoiceConstant.INVOICE_NUONUO || EITaxControlInterfaceName === InvoiceConstant.INVOICE_NUONUO_EI || TaxControlInterfaceName === InvoiceConstant.INVOICE_NUONUO) {
        taxInvalidDate = $store.state.settings.bsLimitInfo.NNTaxInvalidDate
      } else if (EITaxControlInterfaceName === InvoiceConstant.INVOICE_TAX_EASY || EITaxControlInterfaceName === InvoiceConstant.INVOICE_TAX_EASY_THREE || EITaxControlInterfaceName === InvoiceConstant.INVOICE_TAX_EASY_THREE_PLUS ||
        TaxControlInterfaceName === InvoiceConstant.INVOICE_TAX_EASY || TaxControlInterfaceName === InvoiceConstant.INVOICE_TAX_EASY_THREE) {
        taxInvalidDate = $store.state.settings.bsLimitInfo.RJTaxInvalidDate
      } else if (EITaxControlInterfaceName === InvoiceConstant.INVOICE_BWJSY || TaxControlInterfaceName === InvoiceConstant.INVOICE_BWJSY ||
          TaxControlInterfaceName === InvoiceConstant.INVOICE_BAI_WANG_ORIGIN || TaxControlInterfaceName === InvoiceConstant.INTERFACE_BAI_WANG.code) {
        taxInvalidDate = $store.state.settings.bsLimitInfo.BWTaxInvalidDate
      } else if (EITaxControlInterfaceName === InvoiceConstant.INVOICE_AISINO_EI || EITaxControlInterfaceName === InvoiceConstant.INVOICE_HTXX ||
          TaxControlInterfaceName === InvoiceConstant.INVOICE_HTXX || TaxControlInterfaceName === InvoiceConstant.INTERFACE_AISINO.code || TaxControlInterfaceName === InvoiceConstant.INVOICE_AISINO_V2) {
        taxInvalidDate = $store.state.settings.bsLimitInfo.HTTaxInvalidDate
      } else {
        taxInvalidDate = ''
      }
      if (taxInvalidDate && taxInvalidDate < DateUtils.formatStandardDate(new Date())) {
        MessageBox.confirm(lang.t('SystemMaintenance.TaxExpireLimitUse'), lang.t('SystemMaintenance.Prompt'), {
          confirmButtonText: lang.t('common.btn.ok'),
          dangerouslyUseHTMLString: true,
          showCancelButton: false,
          closeOnClickModal: false,
          showClose: false,
          closeOnPressEscape: false,
          type: 'warning'
        }).then(() => {
          resolve(false)
        }).catch(() => {
          resolve(false)
        })
      } else {
        resolve(true)
      }
    })
  }

  /**
   * 移到最后一个view
   * @param visitedViews
   * @param $router
   */
  static toLastView(visitedViews, $router) {
    const latestView = visitedViews.slice(-1)[0]
    if (latestView) {
      $router.push(latestView)
    } else {
      $router.push('/')
    }
  }
}
